import type { Query, QueryClient } from '@tanstack/react-query';
import { markNextWrite } from '../../devtool/channels/cache-write.js';
import { isDevtoolEnabled } from '../events.js';

const writing = new WeakMap<QueryClient, Set<string>>();

export function isConvictionProjectionWrite(qc: QueryClient, hash: string): boolean {
  return writing.get(qc)?.has(hash) === true;
}

/** Display ticks must not acknowledge a fetch, clear invalidation, or advance freshness. */
export function writeConvictionProjection(qc: QueryClient, query: Query, data: unknown): void {
  let hashes = writing.get(qc);
  if (hashes === undefined) {
    hashes = new Set();
    writing.set(qc, hashes);
  }
  hashes.add(query.queryHash);
  try {
    if (isDevtoolEnabled()) markNextWrite(qc, query.queryHash, 'projection');
    query.setState({ data });
  } finally {
    hashes.delete(query.queryHash);
  }
}
